import * as betgalaxy from './TakeAction.styles.betgalaxy';
import * as betprofessor from './TakeAction.styles.betprofessor';
import * as betroyale from './TakeAction.styles.betroyale';
import * as fiestabet from './TakeAction.styles.fiestabet';
import * as goldenrush from './TakeAction.styles.goldenrush';
import * as juicybet from './TakeAction.styles.juicybet';
import * as puntcity from './TakeAction.styles.puntcity';
import * as puntgenie from './TakeAction.styles.puntgenie';
import * as questbet from './TakeAction.styles.questbet';
import * as sterlingparker from './TakeAction.styles.sterlingparker';
import * as vikingbet from './TakeAction.styles.vikingbet';
import * as volcanobet from './TakeAction.styles.volcanobet';
import * as wellbet from './TakeAction.styles.wellbet';
import * as forsport from './TakeAction.styles.forsport';
import * as junglebet from './TakeAction.styles.junglebet';
import * as oldgill from './TakeAction.styles.oldgill';
import * as sugarcastle from './TakeAction.styles.sugarcastle';
import * as buffalobet from './TakeAction.styles.buffalobet';
import * as titanbet from './TakeAction.styles.titanbet';
import * as slambet from './TakeAction.styles.slambet';
import * as gigabet from './TakeAction.styles.gigabet';
import * as betstride from './TakeAction.styles.betstride';
import * as templebet from './TakeAction.styles.templebet';
import * as goldenbet888 from './TakeAction.styles.goldenbet888';
import * as hyperbet from './TakeAction.styles.hyperbet';
import * as bet777 from './TakeAction.styles.bet777';
import * as chromabet from './TakeAction.styles.chromabet';
import * as bet575 from './TakeAction.styles.bet575';
import * as betblast from './TakeAction.styles.betblast';
import * as pyramidbet from './TakeAction.styles.pyramidbet';
import * as magnumbet from './TakeAction.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
